import { useSelector } from "react-redux"
import Map from "../components/campusLife/map"
import Heading from "../components/heading"

const CampusLocation = () => {

    const state = useSelector(state => state.campusLife)
    const campusLife = state?.data?.properties
    const title = campusLife?.title
    const subTitle = campusLife?.subTitle
    const description = campusLife?.description
    const amenities = campusLife?.campusAmenity?.items
    const statistics = amenities?.map(amenity => {
        let ament = amenity?.content?.properties
        return {
            title: ament?.value,
            disc: ament?.label
        }
    })
    return (
        <div className="p-4 md:p-8 md:px-12  xl:pt-16 relative w-full flex flex-col items-center justify-center">
            <div className="grid grid-cols-1 w-full  xl:max-w-[100rem] gap-10 md:grid-cols-2 ">
                <div className="flex flex-col gap-3">
                    <div className="flex-col justify-start items-start gap-4 inline-flex">
                        <Heading name="Campus locations" color="text-blue-700" />
                        <h1 className="self-stretch w-auto xl:max-w-[10ch] text-slate-900 text-5xl font-bold leading-tight ">{title}</h1>
                        <p className="w-auto 2xl:w-[80ch] "><span className="text-sky-950 text-opacity-70 text-3xl font-normal   leading-9">{subTitle}</span></p>
                        <p className="w-auto 2xl:w-[80ch]  text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{description}</p>
                    </div>
                </div>
                <div className="flex w-full items-center justify-center min-h-[30rem] rounded-2xl">
                    <Map />
                </div>
            </div>
            <div className=" w-full lg:max-w-5xl xl:max-w-6xl gap-10 grid grid-cols-[repeat(auto-fit,minmax(11rem,2fr))]">
                {
                    statistics?.map((stat, index) => (
                        <div key={index} className="flex-col justify-center items-center gap-2 inline-flex">
                            <div className="text-blue-700 text-5xl font-bold  ">{stat.title}</div>
                            <div className="text-sky-950 text-opacity-70 text-base font-bold ">{stat.disc}</div>
                        </div>
                    ))
                }
            </div>

        </div>
    )
}

export default CampusLocation